/** Local dummy assets when API has no banner / logo (served from `public/`). */
const base = (process.env.PUBLIC_URL || "").replace(/\/$/, "");

export const EVENT_BUSINESS_PLACEHOLDER_URL = `${base}/assets/images/event-business-logo-placeholder.png`;
export const PLACEHOLDER_BANNER_URL = EVENT_BUSINESS_PLACEHOLDER_URL;
export const PLACEHOLDER_LOGO_URL = EVENT_BUSINESS_PLACEHOLDER_URL;
